import { composeEffects } from '../module';
import { getEntityIdentifier } from '../selectors';

import { SegmentWrapper } from './segmentWrapper';

export const SegmentEffects = composeEffects('segment', compose => ({
  identify: compose.effect(async (e: { userIdentifier: string | number; props?: object }) => {
    return SegmentWrapper.identify(e.userIdentifier, e.props);
  }),
  group: compose.effect(async (e: { entityIdentifier: string; props?: object }) => {
    return SegmentWrapper.group(e.entityIdentifier, e.props);
  }),
  track: compose.statefulEffect(
    getEntityIdentifier,
    async (entityIdentifier, e: { eventName: string; props?: object }
  ) =>
    Promise.resolve(SegmentWrapper.track(e.eventName, { groupId: entityIdentifier, ...e.props }))
  ),
  page: compose.effect(async (e: { pageName: string; props?: { [key: string]: any } }) => {
    return Promise.resolve(SegmentWrapper.page(e.pageName, e.props));
  })
}));
